import { conditions, footerPadding } from "helpers";
import { ConditionName, zIndex } from "interfaces";
import { useAppSelector } from "redux-share/hooks";
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";
import ProgressBar from "./progressbar/progressbar";
import Controllbar from "./controllbar/controllbar";
import DisplaySubtitle from "../../player-components/subtitles/displaySubtitle";

const AutoPlayListIcon = dynamic(() => import("../../player-components/autoPlay/autoPlayListIcon"));
const InstagramEmoji = dynamic(() => import("../../player-components/InstagramEmoji/InstagramEmoji"));

const Footer = () => {
    useAppSelector(({ controller: { lock, isFullScreen } }) => ({ lock, isFullScreen }), shallowEqual);

    return (
        <div id="footer" className="pl-relative" style={{ zIndex: zIndex.footer }}>
            {conditions(ConditionName.showAutoPlayListTouchIcon) && <AutoPlayListIcon />}
            {conditions(ConditionName.isSelectedSubtitle) && <DisplaySubtitle />}
            {!conditions(ConditionName.isLock) && (
                <>
                    <div
                        className={`pl-w-full pl-mx-auto animate__animated animate__faster ${
                            conditions(ConditionName.isActiveElements)
                                ? "animate__fadeIn pl-pointer-events-auto"
                                : "animate__fadeOut pl-pointer-events-none"
                        }`}
                        style={{ paddingLeft: footerPadding(), paddingRight: footerPadding() }}
                    >
                        {conditions(ConditionName.showProgressbar) && <ProgressBar />}
                        <Controllbar />
                    </div>
                    {conditions(ConditionName.showInstagramEmoji) && <InstagramEmoji />}
                </>
            )}
        </div>
    );
};

export default Footer;
